import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SiteFooter, PageHeading, SiteHeader } from 'Components';
import { GlobalStyles } from 'styles';
import { design } from 'utils';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: ${design.colors.white};
  background-color: ${design.colors.gray[1]};
  ${(props) => props.$center && `text-align: center;`}
  ${(props) => props.$vcenter && `margin: auto;`}
`;

const PageContent = styled.main`
  background-color: ${design.colors.gray[1]};
  color: ${design.colors.black};
  flex-grow: 1;
  margin: 0 auto;
  max-width: ${design.breakpoints[14]};
  padding: ${design.spacing[4]} ${design.spacing[4]} ${design.spacing[8]};
  position: relative;
  width: 100%;
  z-index: 2;
  @media screen and (max-width: ${design.breakpoints[14]}) {
    border-width: 0;
  }
  @media screen and (max-width: ${design.breakpoints[10]}) {
    padding: ${design.spacing[4]} ${design.spacing[2]} ${design.spacing[8]};
  }
`;

const PageContainer = ({ center, children, isAdmin, pageHeading, vcenter }) => {
  return (
    <Container
      $center={center ? 'true' : 'false'}
      $vcenter={vcenter ? 'true' : 'false'}
    >
      <GlobalStyles />
      <SiteHeader isAdmin={isAdmin} />
      <PageContent>
        {pageHeading && <PageHeading>{pageHeading}</PageHeading>}
        {children}
      </PageContent>
      <SiteFooter />
    </Container>
  );
};

PageContainer.propTypes = {
  center: PropTypes.bool,
  children: PropTypes.node.isRequired,
  pageHeading: PropTypes.node,
  vcenter: PropTypes.bool,
};

export default PageContainer;
